import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import certificateCreatorActions from 'src/redux/actions/certificateCreator.actions';
import { CertificateSteps } from '../../models/certificate.model';

const CertificateTransactionPolling = () => {
  const dispatch = useDispatch();
  const {
    certificatesTransactionLoading,
    certificatesInTransaction,
    certificatesCompletedTransaction,
    certificatesTransactionTimeoutId,
    draftImportedData,
  } = useSelector((state) => state.certificateCreatorStore, undefined);

  useEffect(() => {
    if (!certificatesTransactionLoading && certificatesInTransaction.length > 0) {
      dispatch(certificateCreatorActions.processBatchThunk(3000));
    } else if (
      certificatesInTransaction.length === 0 &&
      certificatesCompletedTransaction.length > 0
    ) {
      dispatch(
        certificateCreatorActions.setCreatorStep({
          currentStep: CertificateSteps.InvitePeople,
        })
      );
    }

    return () =>
      dispatch(
        certificateCreatorActions.resetCertificateInTransactionFetching(
          certificatesTransactionTimeoutId
        )
      );
  }, [
    dispatch,
    certificatesTransactionTimeoutId,
    certificatesCompletedTransaction,
    certificatesInTransaction,
    draftImportedData.length,
    certificatesTransactionLoading,
  ]);

  return null;
};

export default CertificateTransactionPolling;
